import React, {forwardRef, useImperativeHandle} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    "& .MuiPaper-root": {
      overflow: "auto",
    },
    "& .MuiStepLabel-label": {
      color: "#525252",
    },
    "& .MuiStepLabel-active": {
      color: "#000",
    },
    "& .MuiStepLabel-complete": {
      color: "#000",
    }
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return ['Population Frequency','Disease Databases', 'Computational Predictive Programs','Nucleotide Conservation','Literature','Interpretation','Final Review'];
}

const StepperInterpretation = forwardRef((props, ref) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const { ref1, ref2 } = ref;

  // const handleReset = () => {
  //   setActiveStep(0);
  // };

  useImperativeHandle(ref2, () => ({
    handleNext() {
      if(activeStep < 7 ){
        setActiveStep((activeStep) => activeStep + 1)
      }
    }
  }));

  useImperativeHandle(ref1, () => ({
    handleBack() {
      if(activeStep != 0 ){
        setActiveStep((activeStep) => activeStep - 1)
      }
    }
  }));

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel style={{ padding: 24 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper> 
    </div>
  )
});

export default StepperInterpretation;
